import { CompanyAdmin, CompanyAdminSupportService } from '../../../service/company-admin-support.service';
import { Component, OnInit, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-company-admin-support-popup-table-user-row',
    templateUrl: './row.component.html',
    styleUrls: ['./row.component.scss'],
    standalone: false
})
export class CompanyAdminSupportPopupTableUserRowComponent implements OnInit, OnDestroy {
    @ViewChild('tooltipEmailCopied') public tooltip: NgbTooltip;
    @Input() admin: CompanyAdmin;
    copiedEmail$ = this.companyAdminSupportService.copiedEmail$;

    onCopyHover = false;
    private readonly fb = inject(NonNullableFormBuilder);
    readonly form = this.fb.group({
        select: this.fb.control(false),
    });

    private subscriptions = new Subscription();

    constructor(private companyAdminSupportService: CompanyAdminSupportService) {}

    ngOnInit() {
        this.subscriptions.add(this.form.controls.select.valueChanges.subscribe(() => this.selectUpdate()));
        this.subscriptions.add(this.companyAdminSupportService.selectedAdminsEmails$.subscribe(() => this.selectedUserEmailUpdate()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    copy(tooltip: NgbTooltip) {
        this.companyAdminSupportService.setCopiedEmail(this.admin.email);
        tooltip.open();
        navigator.clipboard.writeText(this.admin.email);
    }

    get isSelected() {
        return this.form.controls.select.value;
    }

    onMouseLeave() {
        this.tooltip.close();
        this.onCopyHover = false;
    }

    onMouseEnter() {
        this.onCopyHover = true;
    }

    /**
     * Select Update
     */
    private selectUpdate(): void {
        this.form.controls.select.value
            ? this.companyAdminSupportService.selectUser(this.admin.email)
            : this.companyAdminSupportService.unselectUser(this.admin.email);
    }

    /**
     * Select User Email Changed
     */
    private selectedUserEmailUpdate(): void {
        if (this.companyAdminSupportService.selectedAdminsEmails?.includes(this.admin.email) && !this.form.controls.select.value) {
            this.form.controls.select.patchValue(true, { emitEvent: false });
        } else if (!this.companyAdminSupportService.selectedAdminsEmails?.includes(this.admin.email) && this.form.controls.select.value) {
            this.form.controls.select.patchValue(false, { emitEvent: false });
        }
    }
}
